module.exports = __webpack_public_path__ + "img/web_header.526a1598.jpg";